import React from 'react';
import { Layout, pageTypes, siteDescription, siteName, routes, AdBox, AdMobileAnchor, AdMobileBanner, AdLeaderboard, AdVideo } from 'gatsby-theme-apollo';
import TierListPreviewCards from '../cards/tier-list-preview-card';
import Footer from './footer';
import GameContent from './content';
import { Flex } from '../layout/flex';
import EmptyState from '../status/empty-state';
import CTA from '../cta';

import Section from '../layout/section';
import { ContentBox } from '../layout/content-box';
import { MyTierLists } from '../content/my-content';

/**
  Renders Tier List Hub pages that aggregate saved tier lists @ the following URLs
  /game-name/tier-list/
*/
const TierListHubPage = ({ location, pageContext }) => {
  const pageType = pageTypes.TIER_LIST_HUB;

  const { tierListPreviews, featuredTierListExplanation, gameName, EntityConfigs } = pageContext;

  let primaryEntityTerm;

  if (EntityConfigs) {
    primaryEntityTerm = EntityConfigs.find(term => term.plural);
  }

  const pageHeader = primaryEntityTerm
    ? `${gameName} Best ${primaryEntityTerm.plural}`
    : `${gameName} Tier Lists`;
  const pageDescription = `Tier lists for ${gameName}. ${siteDescription}`;
  const pageTitle = `${pageHeader} | ${siteName}`;
  let featuredTierListPreviews = [];
  let recentTierListPreviews = [];

  if (tierListPreviews) {
    featuredTierListPreviews = featuredTierListPreviews.concat(
      tierListPreviews.filter(tierListPreview => tierListPreview.featured)
    );
    recentTierListPreviews = recentTierListPreviews.concat(
      tierListPreviews.filter(tierListPreview => !tierListPreview.featured)
    );
  }

  const crumbs = [{ text: `${gameName} Wiki`, url: routes.GameHub(gameName), hide: true }];

  return (
    <Layout
      location={location}
      title={pageTitle}
      gameName={gameName}
      description={pageDescription}
      pageType={pageType}
    >
      <AdMobileAnchor placementId={'gh-anchor-' + pageType +'-bottom'} anchorType='bottom' offset='47' />
      <GameContent header={pageHeader} crumbs={crumbs} showTopShareBar>
        <AdMobileBanner placementId={"gh-mobilebanner-" + pageType + "-top"} />
        <AdLeaderboard placementId={"gh-leaderboard-" + pageType + "-top"} />
        
        <MyTierLists />
        <>
          {tierListPreviews && tierListPreviews.length !== 0 ? (
            <>
              {featuredTierListPreviews && featuredTierListPreviews.length !== 0 && (
                <Section title="Featured Tier Lists" fullWidth transparent>
                  {featuredTierListExplanation && (
                    <Flex>
                      <ContentBox
                        solidBackground
                        style={{ padding: `20px`, textAlign: 'left', maxWidth: `900px` }}
                      >
                        {featuredTierListExplanation}
                      </ContentBox>
                    </Flex>
                  )}
                  <TierListPreviewCards tierListPreviews={featuredTierListPreviews} />
                </Section>
              )}

              {recentTierListPreviews && recentTierListPreviews.length !== 0 && (
                <Section title="Recent Tier Lists" fullWidth transparent>
                  <TierListPreviewCards tierListPreviews={recentTierListPreviews} limit={24} />
                </Section>
              )}

              <Section flushContent>
                <AdBox placementId={"gh-box-" + pageType + "-bottom"} />
              </Section>
            </>
          ) : (
            <EmptyState>
              No {gameName} Tier Lists have been created yet. You can be the first!
            </EmptyState>
          )}
        </>
        <Footer>
          <AdVideo placementId={'gh-video-' + pageType + '-floating'} />
          <CTA campaignKey="Discord" />
        </Footer>
      </GameContent>
    </Layout>
  );
};

export default TierListHubPage;
